import type {
  BestOffersParams,
  DistributorOffersParams,
  DrugOffersParams,
  DrugsSearchParams,
  FetchDrugImagesParams,
  FetchDrugOrdersParams,
  ListDrugsParams,
} from '@/api/domains/drugs.api';
import { paramsToQueryKey } from '@/shared/lib/react-query';

const PREFIX = 'drugs';

export const DrugsQueryKeys = {
  root: [PREFIX],

  refreshCurrentSearch: () => [PREFIX, 'search'],
  drug: (drugId: string | number | undefined) => [PREFIX, drugId?.toString(), 'view'],
  drugStatuses: (drugId?: number) => [PREFIX, drugId?.toString()],
  listDrugs: (params: ListDrugsParams) => paramsToQueryKey([PREFIX, 'list'], params),
  getSearchDrugKey: (params: DrugsSearchParams) => paramsToQueryKey([PREFIX, 'search'], params),
  fetchDrugs: (params?: DrugsSearchParams) => paramsToQueryKey([PREFIX, 'search'], params),
  fetchDosages: (drugId?: number) => [PREFIX, 'dosages', drugId?.toString()],
  getInstructionForPharmacist: (drugId?: number) => [PREFIX, drugId?.toString(), 'script'],
  getOffersKey: (drugId: number | null, params?: DrugOffersParams) =>
    paramsToQueryKey([PREFIX, 'offers', String(drugId)], params),

  getInstructionKey: (drugId: number) => [PREFIX, drugId.toString(), 'instruction'],

  getImagesKey: (params: Partial<FetchDrugImagesParams>) => paramsToQueryKey([PREFIX, 'images'], params),

  receptionFeatures: (drugId?: string | number) => [PREFIX, drugId?.toString(), 'receptionFeatures'],

  getLoadOffersKey: (distributorId?: number) => [PREFIX, 'load-offers', distributorId],

  getDrugOrdersKey: (drugId: number | null, params?: Omit<FetchDrugOrdersParams, 'drug_id'>) =>
    paramsToQueryKey([PREFIX, String(drugId), 'orders'], params),

  getByDistributorOffersKey: (distributorId?: number, params?: DistributorOffersParams) =>
    paramsToQueryKey([PREFIX, 'by-distributor-offers', String(distributorId)], params),

  getBestOffersKey: (params?: BestOffersParams) => paramsToQueryKey([PREFIX, 'best-offers'], params),
} as const;
